import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import { SET_CLASSBOOK_FITNESS_INDICATORS_LIST, SET_EVENT_LEVELS_LOADING, SET_FITNESS_INDICATORS_LIST } from "./types";


export const getFitnessIndicators = () => async (dispatch) => {
  try {
    const { data } = await api.get('/physical_training');
    dispatch({ type: SET_FITNESS_INDICATORS_LIST, payload: data });
  } catch (ERR) {
  }
}

export const getClassbookFitnessIndicators = (trmid, cid, gid) => async (dispatch) => {
  try {
    const { data } = await api.get(`/physical_training/journal/${trmid}/${cid}/${gid}`);
    dispatch({ type: SET_CLASSBOOK_FITNESS_INDICATORS_LIST, payload: data });
  } catch (ERR) {
  }
}

export const createFitnessIndicators = (reqData, closeModal) => async (dispatch) => {
  let success;
  try {
    dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: true });
    await api.post(`/physical_training`, reqData);
    success = true;
    createNotification('success', 'Успешно');
    await dispatch(getFitnessIndicators());
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Не удалось создать запись';
    createNotification('error', errorMessage);
  } finally {
    dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: false });
    return success;
  }
}

export const updateFitnessIndicators = ({ iid, ...reqData }, closeModal) => async (dispatch) => {
  let success;
  try {
    dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: true });
    await api.put(`/physical_training/${iid}`, reqData);
    success = true;
    createNotification('success', 'Успешно');
    await dispatch(getFitnessIndicators());
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Не удалось изменить запись';
    createNotification('error', errorMessage);
  } finally {
    dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: false });
    return success;
  }
}

export const deleteFitnessIndicators = (id) => async (dispatch) => {
  try {
    dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: true });
    await api.delete(`/physical_training/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getFitnessIndicators());
  } catch (error) {
    const message = error.response?.data?.error || 'Ошибка';
    createNotification('error', message);
  } finally {
    dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: false });
  }
}
